import { Rpc } from '../rpc';
import { RpcInboundClient } from '../rpc-inbound-client';
import { RpcAzureOperation, RpcAzureOperationResult, RpcAzureRequestKey } from './rpc-azure-model';

export class RpcAzureRequestClient {
    /**
     * The azure request client call.
     *
     * @param data the RpcLogRecord object.
     * @return Promise<RpcAzureOperationResult> the promise object with operation result.
     */
    public static azureRequest(rpc: Rpc, data: RpcAzureOperation): Promise<RpcAzureOperationResult> {
        return RpcInboundClient.call(rpc, RpcAzureRequestKey.command, RpcAzureRequestKey.version, data);
    }
}
